<template>
  <div @click.stop=""
       class="w-full bg-[#283344] border-zt-light select-none relative cursor-default border-y
         xl:border xl:w-[359px] xl:rounded-md">
    <div v-if="window.size.desktop" class="absolute top-px right-6 -translate-y-full">
      <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 0L21.3923 17.25H0.607696L11 0Z" fill="#283444"/>
      </svg>
    </div>
    <div class="flex justify-between items-center py-5 px-4">
      <span @click="changeMonth(-1)" class="cursor-pointer zt-hover p-3 -m-3">
        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 1.41L2.67341 6L7 10.59L5.66802 12L4.29138e-07 6L5.66802 -1.7909e-06L7 1.41Z" fill="white"/>
        </svg>
      </span>
      <span class="capitalize text-sm font-medium">
        {{ selectedMonth.monthLong + ' ' + selectedMonth.year }}
      </span>
      <span @click="changeMonth(1)" class="cursor-pointer zt-hover p-3 -m-3">
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 10.59L4.94467 6L0 1.41L1.52227 0L8 6L1.52227 12L0 10.59Z" fill="white"/>
        </svg>
      </span>
    </div>
    <div class="bg-zt-dark h-[31px] grid grid-cols-7 items-center text-center 
              text-zt-more font-light text-[10px]">
      <span>PON</span>
      <span>WTO</span>
      <span>ŚRO</span>
      <span>CZW</span>
      <span>PIĄ</span>
      <span>SOB</span>
      <span>NDZ</span>
    </div>
    <div class="grid grid-cols-7 gap-y-2 items-center font-semibold text-sm py-2.5">
      <div v-for="day in monthDays" :key="day.toMillis()"
          @click="!availableDaysInterval.contains(day) ? openTooltip($event) : dayClick(day)"
          @mouseleave="hideTooltip($event)"
          class="col-span-1 h-8 flex items-center justify-center cursor-pointer transition-all duration-300"
          :class="{
            '!bg-[#3A4B64] group': selectedDaysInterval.contains(day) || day.equals(selectedDate),
            '!rounded-l-[10px] !rounded-r-[10px]': day.equals(selectedDate),
            'text-zt-more': day.month !== selectedMonth.month && availableDaysInterval.contains(day),
            'opacity-30 !cursor-default': !availableDaysInterval.contains(day),
            'hover:bg-zt-light/35 hover:rounded-[10px]': !selectedDaysInterval.contains(day) &&
                                                           availableDaysInterval.contains(day)
          }"
          :style="'grid-column-start: '+day.weekday+';'"
          data-bs-custom-class="modal-tooltip"
          :data-bs-trigger="!availableDaysInterval.contains(day) ? 'manual' : undefined"
          :data-bs-toggle="!availableDaysInterval.contains(day) ? 'tooltip' : undefined"
          :data-bs-placement="!availableDaysInterval.contains(day) ? 'bottom' : undefined"
          :data-bs-delay="!availableDaysInterval.contains(day) ? '500' : undefined"
          :title="!availableDaysInterval.contains(day) ? 'Niedostępne' : undefined">
        <span class="transition-opacity group-hover:opacity-75" :class="{'text-zt-red relative' : day.equals(today)}">
        {{day.day}}
      </span>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime, Interval } from 'luxon';
import utils_mixin from '../../mixins/utils_mixin';

export default {
  name: "BetsCalendarModal",
  mixins: [utils_mixin],
  inject: ['WP'],
  emits: ['close-calendar'],
  props: {
    selectedDate: {
      type: DateTime,
      required: true,
    }
  },
  data() {
    return {
      selectedMonth: this.selectedDate.startOf('month'),
      monthDays: [],
      today: DateTime.now().startOf('day'),
    }
  },
  mounted() {
    this.getMonthDays();
  },
  computed: {
    selectedDaysInterval() {
      return Interval.fromDateTimes(this.selectedDate.startOf('day'), this.selectedDate.endOf('day'));
    },
    availableDaysInterval() {
      const startDate = DateTime.fromISO('2022-04-01');
      const endDate = DateTime.now().plus({ days: 2 });
      return Interval.fromDateTimes(startDate, endDate);
    }
  },
  methods: {
    changeMonth(direction) {
      this.selectedMonth = this.selectedMonth.plus({month: direction});
      this.getMonthDays();
    },
    getMonthDays() {
      this.monthDays = [];
      if ( this.selectedMonth.weekday !== 1 ) {
        let lastMonthDay = this.selectedMonth.minus({months: 1}).endOf('month').startOf('week');
        while ( lastMonthDay.month === this.selectedMonth.minus({months: 1}).month ) {
          this.monthDays.push(lastMonthDay);
          lastMonthDay = lastMonthDay.plus({days: 1})
        }
      }

      for ( let i = 0; i < this.selectedMonth.daysInMonth; i++ ) {
        this.monthDays.push(this.selectedMonth.plus({days: i}));
      }
      
      if ( this.selectedMonth.endOf('month').weekday !== 7 ) {
        let nextMonthDay = this.selectedMonth.plus({months: 1}).startOf('month');
        do {
          this.monthDays.push(nextMonthDay);
          nextMonthDay = nextMonthDay.plus({days: 1})
        } while ( nextMonthDay.weekday !== 1 )
      }
      setTimeout(this.refreshTooltips, 200);
    },
    redirectToPostLink(date) {
      axios.post(this.WP.ajaxUrl, {
        endpoint: 'api_get_td_post_id_by_date',
        daily_bets_date: date,
      })
      .then(response => {
        if (response.data.success) {
          window.location.href = `/?p=${response.data.data}`;
        }
      });
    },
    dayClick(day) {
      if (day.equals(this.today) && this.selectedDaysInterval.contains(day)) {
        this.$emit('close-calendar');
        return;
      }
      let formattedDate = day.toFormat('yyyy-MM-dd HH:mm:ss');
      this.redirectToPostLink(formattedDate);
    },
    hideTooltip(event) {
      for (const element of event.composedPath()) {
        if (typeof element === 'object' && element !== null && 'getAttribute' in element && element.hasAttributes()) {
          for (const attr of element.attributes) {
            if (attr.name === 'data-tooltip-created') {
              setTimeout(() => {
                let tooltip = Tooltip.getInstance(element);
                tooltip.hide();
              }, 0);
              return;
            }
          }
        }
      }
    },
    openTooltip(event) {
      for (const element of event.composedPath()) {
        if (typeof element === 'object' && element !== null && 'getAttribute' in element && element.hasAttributes()) {
          for (const attr of element.attributes) {
            if (attr.name === 'data-tooltip-created') {
              setTimeout(() => {
                let tooltip = Tooltip.getInstance(element);
                tooltip.show();
              }, 0);
              return;
            }
          }
        }
      }
    },
  },
}
</script>